import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {useCallback} from "react";

import {AddIcon} from "../../react/components/Icons/AddIcon";
import {CheckIcon} from "../../react/components/Icons/CheckIcon";
import {memoWithType} from "../../react/utils/memoWithType";
import {Badge, BadgeIcon, BadgeText} from "../ui/badge";
import {Pressable} from "../ui/pressable";

type Props<T> = {
    isCheck: boolean;
    value: T;
    error?: boolean;
    onClick: (value: T, isCheck: boolean) => void;
    isDisabled?: boolean;
    children: string;
};

const style = tva({
    base: "",
    variants: {
        error: {
            true: "border-error-600",
            false: ""
        }
    }
});

function CheckButton<T>({isCheck, isDisabled, value, error, onClick, children}: Props<T>) {
    const Icon = isCheck ? CheckIcon : AddIcon;

    const handlePress = useCallback(() => {
        onClick(value, !isCheck);
    }, [isCheck, onClick, value]);

    return (
        <Pressable disabled={isDisabled} onPress={handlePress}>
            <Badge className={style({error})} size="md" variant={isCheck ? "subtle" : "outline"}>
                <BadgeIcon as={Icon} />
                <BadgeText>{children}</BadgeText>
            </Badge>
        </Pressable>
    );
}

export default memoWithType(CheckButton);
